import type { JSX } from 'solid-js';
// eslint-disable-next-line @nx/enforce-module-boundaries -- CustomSelect's menu mode is required for the portal-positioned, mixed-state access level trigger
import { CustomSelect } from '@tcweb/connect-ui';
import type { IssueAccessBucket } from '../../types/issue-permissions.types';

export interface AccessLevelDropdownProps {
  readonly value: IssueAccessBucket;
  onChange(value: IssueAccessBucket): void;
  readonly isMixed?: boolean;
  readonly disabled?: boolean;
}

const EDIT_LABEL = 'Edit access';
const VIEW_LABEL = 'Read only';
const MIXED_LABEL = 'Mixed access';

const ACCESS_LABEL_MAP: Record<IssueAccessBucket, string> = {
  edit: EDIT_LABEL,
  view: VIEW_LABEL,
};

const ACCESS_OPTIONS: readonly IssueAccessBucket[] = ['edit', 'view'];

export function AccessLevelDropdown(
  props: Readonly<AccessLevelDropdownProps>
): JSX.Element {
  return (
    <CustomSelect
      name="access-level"
      label="Access level"
      options={ACCESS_OPTIONS}
      getDisplayValue={(item) => ACCESS_LABEL_MAP[item as IssueAccessBucket]}
      value={props.value}
      indeterminate={props.isMixed}
      indeterminateLabel={MIXED_LABEL}
      disabled={props.disabled}
      renderMode="menu"
      usePortal
      hideLabel
      triggerClassName="access-level-dropdown-trigger"
      linkClassName="p-0 small ml-0"
      arrowIconClassName="i16"
      menuClassName="access-level-dropdown-menu"
      data-cy="access-level-dropdown"
      onSelect={(value) => props.onChange(value as IssueAccessBucket)}
    />
  );
}
